import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { storeSettings } from 'repositories/redux/settings/store.settings'
import { useQueryGetSettings } from 'repositories/restfuls/entities/webs/useQuery.get.settings'

export const useGetSettings = (options = {}) => {
  const dispatch = useDispatch()
  const {
    isSuccess,
    data,
    isError,
    error,
    isLoading,
    isUninitialized,
    refetch,
  } = useQueryGetSettings({}, options)

  useEffect(() => {
    if (isSuccess) {
      dispatch(storeSettings.actions.setSettings(data))
    }
  }, [isSuccess])

  return [
    {
      isUninitialized,
      isLoading,
      isSuccess,
      isError,
      error,
      data,
    },
    {
      refetch,
    },
  ]
}
